import { Link, styled } from 'opensolar-ui'
import { CardWrapper } from './styles'

const StyledLink = styled(Link, { name: 'StyledLink' })({
  width: 249,
})
const CardContent = styled('div', { name: 'CardContent' })({
  fontWeight: 500,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 20,
})
const CardImg = styled('object', { name: 'CardImg' })({
  height: 300,
  width: 210,
  borderRadius: 8,
})

const CardTitle = styled('span', { name: 'CardTitle' })({
  maxWidth: 210,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  color: 'black',
})

const ResourcesCard = ({ resource, onClick }) => {
  return (
    <StyledLink
      key={'resource-' + resource.id}
      href={resource.url}
      target="_blank"
      download={'expo_resource'}
      onClick={onClick}
    >
      <CardWrapper>
        <CardContent>
          <CardImg data={resource.url} type="application/pdf" />
          <CardTitle>{resource.title}</CardTitle>
        </CardContent>
      </CardWrapper>
    </StyledLink>
  )
}
export default ResourcesCard
